import * as L from "leaflet";
import "./leaflet-search-coordinates.css";
import React from "react";
import { renderToString } from "react-dom/server";
import SearchIcon from "@material-ui/icons/Search";
import { Input } from "reactstrap";

L.Control.SearchCoordinates = L.Control.extend({
  initialize: function () {},
  search: function (map, longitude, latitude) {
    const point = L.latLng(latitude, longitude);
    map.eachLayer(function (layer) {
      layer.closePopup();
    });
    map.fireEvent("click", {
      latlng: point,
      layerPoint: map.latLngToLayerPoint(point),
      containerPoint: map.latLngToContainerPoint(point),
    });
  },
  onAdd: function (map) {
    const container = L.DomUtil.create(
      "div",
      "leaflet-search-coordinates-container"
    );
    L.DomEvent.disableClickPropagation(container);
    container.innerHTML = renderToString(
      <div>
        <div
          style={{
            marginBottom: 5,
            fontSize: 12,
            fontWeight: "bold",
            userSelect: "none",
          }}
        >
          Insert coordinates
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ maxWidth: 110 }}>
            <Input
              type="number"
              placeholder="Latitude"
              id="leaflet-search-latitude"
              bsSize="sm"
            />
          </div>
          <div style={{ width: 10 }} />
          <div style={{ maxWidth: 110 }}>
            <Input
              type="number"
              placeholder="Longitude"
              id="leaflet-search-longitude"
              bsSize="sm"
            />
          </div>

          <div style={{ width: 10 }} />
          <div
            id="leaflet-search-button"
            style={{
              width: 31,
              height: 31,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgb(17, 166, 34)",
              borderRadius: 3.2,
              cursor: "pointer",
            }}
          >
            <SearchIcon style={{ color: "white" }} />
          </div>
        </div>
      </div>
    );

    container
      .querySelector("#leaflet-search-button")
      .addEventListener("click", () => {
        const longitude = container.querySelector(
          "#leaflet-search-longitude"
        ).value;
        const latitude = container.querySelector(
          "#leaflet-search-latitude"
        ).value;
        this.search(map, longitude, latitude);
      });
    return container;
  },
});

export default L.control.searchCoordinates = function () {
  return new L.Control.SearchCoordinates();
};
